import { UseQueryOptions } from '@tanstack/react-query';

import { Campaign } from 'domains/campaigns/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

type UseArchivedCampaignsParams = {
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<Campaign[], Error>;
};

const useArchivedCampaigns = ({ searchTerm, reactQueryOptions }: UseArchivedCampaignsParams = {}) => {
    const axiosOptions = {
        ...(searchTerm?.trim() && { params: { searchTerm: searchTerm.trim() } }),
    };

    return useQuery<Campaign[]>(
        [...QueryKeys.ARCHIVED_CAMPAIGNS, searchTerm],
        CuredApiPaths.CAMPAIGNS_ARCHIVED_LIST,
        reactQueryOptions,
        axiosOptions
    );
};

export default useArchivedCampaigns;
